const styles = (theme) => ({
  container: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 0,

    [theme.breakpoints.up('sm')]: {
      boxShadow: `${theme.boxShadow?.container}`,
    },
  },
  gridContainer: {
    height: '100%',
    flexDirection: 'column',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent',
    },
  },
});

export default styles;
